import React, {useEffect} from 'react';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers.js';
import {setActiveLobbyTab, setSelectedAbroadPackage} from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice.js';
import {lobbyTabsEnum} from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadVariables.js';
import {connect} from 'react-redux';
import {ClientType, PackageOrigin} from '../CellcomAbroadLobbyBlock/Shared/Models/AbroadPackageModels';
import {isMobile} from 'react-device-detect';
import {dwhAbroadAddonPackagePage} from '../CellcomAbroadLobbyBlock/dwhReports';
import {getUrlFromEpiLink} from '../../../utilities/StringHelpers/StringHelpers';
import SelfCareAbroadPackagesPopular from './SelfCareAbroadPackagesPopular';
import AbroadWithoutPackageImg from './images/yellowWarning.svg';
import ArrowImg from './images/arrow.svg';
import {dwhViewAbroadPackage} from 'app/Components/Page/SelfCarePage/partials/header/dwhReports';

const SelfCareAbroadMarketPopularMain = (props) => {
  const noAbroadNoPackageTitle = isMobile ? props.iContent.noAbroadNoPackageTitleMobile.value : props.iContent.noAbroadNoPackageTitle.value;
  const noAbroadNoPackageSubTitle = isMobile
    ? props.iContent.noAbroadNoPackageSubTitleMobile.value
    : props.iContent.noAbroadNoPackageSubTitle.value;
  const abroadNoPackagesMainHeading = isMobile
    ? props.iContent.abroadNoPackageTitleMobile.value
    : props.iContent.abroadNoPackageTitle.value;
  const abroadNoPackageSubHeading = isMobile
    ? props.iContent.abroadNoPackageSubTitleMobile.value
    : props.iContent.abroadNoPackageSubTitle.value;
  const buttonText = props.iContent.buttonText.value;
  const businessPackagesList = props.iContent.businessPackagesList.expandedValue;
  const privatePackagesList = props.iContent.privatePackagesList.expandedValue;
  const lobbyFolderReference = props.iContent.lobbyFolderReference.value?.id;
  const lobbyFolderReferenceUrl = props.iContent.lobbyFolderReference.value?.url;
  const pageRefToExtendedPackagesPrivate = getUrlFromEpiLink(props.iContent.pageRefToExtendedPackagesPrivate);
  const pageRefToExtendedPackagesBusiness = getUrlFromEpiLink(props.iContent.pageRefToExtendedPackagesBusiness);
  const costumerFirstName =
    props.selfCareData?.selectedSubscriber?.productFirstName || props.authentication?.loginData?.userDetails?.firstName;
  const costumerLastName =
    props.selfCareData?.selectedSubscriber?.productLastName || props.authentication?.loginData?.userDetails?.lastName;
  const idNumber = props.selfCareData?.selectedSubscriber?.productId || props.authentication?.loginData?.userDetails?.IDNumber;
  const clientType = props.selfCareData?.selectedSubscriber?.isBusinness ? 1 : 0;
  const clientMobile =
    props.selfCareData?.selectedSubscriber?.productSubscriberNo || props.authentication?.loginData?.userDetails?.contactNumber || '';
  const packageList = (props.selfCareData?.selectedSubscriber?.isBusinness ? businessPackagesList : privatePackagesList) || [];

  const convertClientTypeToLobbyTabsEnum = () => {
    if (clientType === 0) return lobbyTabsEnum.PRIVATE;
    else if (clientType === 1) return lobbyTabsEnum.BUSINESSACCOUNT;
  };

  const convertClientTypeToClientTypeEnum = () => {
    if (clientType === 0) return ClientType.PRIVATE;
    else if (clientType === 1) return ClientType.BUSINESS;
  };

  const requestPackagePopular = () => {
    const request = {
      socIdList: packageList?.map((value) => value.sockCode.value),
      blockId: lobbyFolderReference,
      clientType: convertClientTypeToClientTypeEnum(),
    };
    return request;
  };

  const queryUrl = `?blockId=${lobbyFolderReference}?clientType=${convertClientTypeToClientTypeEnum()}`;

  const dwhParams = {
    channel:
      props.cellcomAbroad?.activeLobbyTab && props.cellcomAbroad?.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate',
    param1: props.cellcomAbroad?.isJETAuthentication ? 'JET' : 'WEBSITE',
    actionType: 'Addon Package Page',
    costumerName: costumerFirstName + ' ' + costumerLastName,
    idNumber: idNumber,
    subscriber: clientMobile,
  };

  const urlToExtendedPackages = clientType === 0 ? pageRefToExtendedPackagesPrivate : pageRefToExtendedPackagesBusiness;

  useEffect(() => {
    if (urlToExtendedPackages) {
      dwhAbroadAddonPackagePage({
        message: 'Addon Package Page Displayed',
        ...dwhParams,
      });
    }
  }, []);

  useEffect(() => {
    if (clientMobile) {
      const customerName = `${props.selfCareData?.selectedSubscriber?.productFirstName} ${props.selfCareData?.selectedSubscriber?.productLastName}`;
      const subscriber = clientMobile;
      const idNumber = null;
      const ban = props.selfCareData?.selectedSubscriber?.ban;
      const psid = null;
      const crmId = null;
      const param1 = null;
      const param9 = null;
      const param10 = null;
      dwhViewAbroadPackage(customerName, subscriber, idNumber, ban, psid, crmId, param1, param9, param10);
    }
  }, [clientMobile]);

  const orderEvent = (packageData) => {
    props.setActiveLobbyTab(convertClientTypeToLobbyTabsEnum());
    props.setSelectedAbroadPackage({
      selectedPackage: packageData,
      folderType: convertClientTypeToClientTypeEnum(),
      startedFromPackage: true,
      selectedOnSalePageFlag: true,
    });
    prepareUrl(lobbyFolderReferenceUrl, props.context, queryUrl);
    if (urlToExtendedPackages) {
      dwhAbroadAddonPackagePage({
        message: 'Addon Package Buy Button Clicked',
        param2: props.cellcomAbroad.selectedAbroadPackage?.socCode,
        ...dwhParams,
      });
    }
  };

  return (
    <SelfCareAbroadPackagesPopular
      id={props.iContent.contentLink.id}
      requestPackagePopular={requestPackagePopular()}
      orderEvent={orderEvent}
      context={props.context}
      isPopularMarketOrLobby={PackageOrigin.POPULAR_MARKET}
      subscriber={props.subscriber}
      noAbroadNoPackageMainHeading={noAbroadNoPackageTitle}
      noAbroadNoPackageSubHeading={noAbroadNoPackageSubTitle}
      abroadNoPackagesMainHeading={abroadNoPackagesMainHeading}
      abroadNoPackageSubHeading={abroadNoPackageSubHeading}
      buttonText={buttonText}
      AbroadWithoutPackageImg={AbroadWithoutPackageImg}
      ArrowImg={ArrowImg}
      urlToExtendedPackages={urlToExtendedPackages}
    />
  );
};

const mapStateToProps = (state) => ({
  cellcomAbroad: state.cellcomAbroad,
  userData: state.authentication?.loginData?.userDetails,
  authentication: state.authentication,
  selfCareData: state.selfcarePage,
  subscriber: state.selfcarePage?.selectedSubscriber,
});

export default connect(mapStateToProps, {
  setActiveLobbyTab,
  setSelectedAbroadPackage,
})(SelfCareAbroadMarketPopularMain);
